<template>
  <b-modal 
      title="Add File" 
      :visible="show"
      ok-variant="primary"
      ok-title="Add"
      cancel-variant="outline-secondary"
      @ok="saveFile"
      @hide="hideModal"
    >
      <ValidationObserver ref="fileForm">
        <b-form>
          <b-form-group label="File">
            <ValidationProvider name="File" rules="required" v-slot="{ errors }">
              <b-form-file v-model="form.file" :state="errors[0] ? false : null"></b-form-file>
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </b-form-group>

          <b-form-group label="Document type">
            <ValidationProvider name="Document type" rules="required" v-slot="{ errors }">
              <b-form-select 
                v-model="form.docType" 
                :options="docTypes" 
                value-field="id" 
                text-field="name"
                :state="errors[0] ? false : null"  
              >
                <template v-slot:first>
                  <b-form-select-option :value="null"></b-form-select-option>
                </template>
              </b-form-select>
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </b-form-group>
        </b-form>
      </ValidationObserver>
    </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  components: { ValidationProvider, ValidationObserver },
  model: {
    prop: 'show',
    event: 'hide'
  },
  props: {
    show: Boolean,
    docTypes: Array
  },
  data() {
    return {
      form: {
        file: null,
        docType: null
      }
    }
  },
  methods: {
    saveFile() {
      this.$refs.fileForm.validate().then(success => {
        if (!success) {
          return;
        } else {
          const docType = this.docTypes.find(d => d.id === this.form.docType);

          this.$emit('file', { file: this.form.file, companyDocTypeId: docType.id, docTypeName: docType.name });
          this.$emit('hide', false);
        }
      });
    },
    hideModal(evt) {
      if (evt.trigger === 'ok') {
        evt.preventDefault();
      } else {
        this.$emit('hide', false);
        this.clearForm();
      }
    },
    clearForm() {
      this.$refs.fileForm.reset();
      this.form.file = null;
      this.form.docType = null;
    }
  }
}
</script>